import { ApiLandingPagePlaylist } from '@storefronts/common-types'
import { useMemo, useState } from 'react'
import { ActiveIndexType } from '../context/types'
import { ViddyCoreContext } from '../context/viddyCoreContext'
import { VideoContext } from '../context/viddyVideoContext'
import { videoToPlaylistPlayerVideo } from '../utils/helpers'

export const useViddyCoreContextSetup = (
    playlist: ApiLandingPagePlaylist | null,
) => {
    const [indexes, setIndexes] = useState<ActiveIndexType>({
        mainIndex: 0,
        subIndexes: [0],
    })

    const playerVideo = useMemo(() => {
        if (!playlist) return null
        const currentVideo =
            playlist.videos[indexes.subIndexes[indexes.mainIndex]]
        if (!currentVideo) return null
        return videoToPlaylistPlayerVideo(currentVideo, playlist)
    }, [playlist, indexes])

    const coreStore: ViddyCoreContext = {
        indexes,
        setIndexes,
        playerVideo,
    }

    return coreStore
}

export const useVideoContextSetup = () => {
    const [firstVideoReady, setFirstVideoReady] = useState(false)
    const [isLPM, setIsLPM] = useState(false)

    const [isMuted, setIsMuted] = useState(true)
    const [isBlurred, setIsBlurred] = useState(false)

    const [videoTapped, setVideoTapped] = useState(false)
    const [shouldPlay, setShouldPlay] = useState(true)

    const videoContextStore: VideoContext = {
        isMuted,
        setIsMuted,
        isBlurred,
        setIsBlurred,
        firstVideoReady,
        setFirstVideoReady,
        isLPM,
        setIsLPM,
        videoTapped,
        setVideoTapped,
        shouldPlay,
        setShouldPlay,
    }

    return videoContextStore
}
